import {  get } from "../../service/api";

const GetIncomeTransaction = async (merchantId,merchantSettleId) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/incomeTransaction`);
        return response;
    } catch (error) {
        console.error('Error GetIncomeTransaction:', error);
        throw error;
    }
};

export default GetIncomeTransaction;